import { render, staticRenderFns } from "./listItem.vue?vue&type=template&id=0fb4b217&scoped=true"
import script from "./listItem.vue?vue&type=script&lang=js"
export * from "./listItem.vue?vue&type=script&lang=js"
import style0 from "./listItem.vue?vue&type=style&index=0&id=0fb4b217&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb4b217",
  null
  
)

export default component.exports